import React, { useEffect, useState } from 'react';
import logoImg from '@/static/logo/icon_web_logo.png';
import { Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import style from './index.module.css';

interface HeaderProps {
  changeLang: Function
}

function Header(props: HeaderProps) {
  const nav = useNavigate();

  const [curLangLabel, setLang] = useState('english');

  const items = [
    {
      label: <div onClick={() => onChangeLang('english')}>English</div>,
      key: 'english',
    },
    {
      label: <div onClick={() => onChangeLang('chinese')}>中文</div>,
      key: 'chinese',
    },
  ];

  useEffect(() => {
    let lang = localStorage.getItem('curLangLabel');
    if (!lang || lang === 'null') {
      lang = 'english';
    }
    onChangeLang(lang as any);
  }, [])

  function gotoHome() {
    nav('/');
  }

  function gotoAbout() {
    nav('/about');
  }

  function onChangeLang(type:any) {
    setLang(type);
    props.changeLang(type);
    localStorage.setItem('curLangLabel', type);
  }

  return (
    <div className={style.header}>
      <img className={style.logo} src={logoImg} alt={''} />
      <div className={style.tool}>
        <div className={style.toolBtn} onClick={gotoHome}>{curLangLabel === 'english' ? 'Home' : '首页'}</div>
        <div className={style.toolBtn} onClick={gotoAbout}>{curLangLabel === 'english' ? 'About us' : '关于我们'}</div>
        <div className={style.selectBtn}>
          <Dropdown menu={{ items }} trigger={['click']}>
            <div>
              <Space>
                { curLangLabel === 'english' ? 'English' : '中文' }
                <DownOutlined  size={12}/>
              </Space>
            </div>
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

export default Header;
